import React, { PureComponent } from 'react';
import ImageProxy from '../ImageProxy';

export interface ImageProps {
  src?: string;
  w?: number;
  h?: number;
  align?: string;
  padding?: number;
  shouldUpscale?: boolean;
}

export type ImageState = TypeMePlease;

export default class Image extends PureComponent<ImageProps, ImageState> {
  constructor(props) {
    super(props);

    this.setImageLoaded = this.setImageLoaded.bind(this);

    this.state = { imageLoaded: false };
  }

  componentDidUpdate(prevProps) {
    if (this.props.src !== prevProps.src) {
      this.setState({ imageLoaded: false, imageSize: { width: 0, height: 0 } });
    }
  }

  setImageLoaded(e) {
    this.setState({ imageLoaded: true, imageSize: { width: e.currentTarget.width, height: e.currentTarget.height } });
  }

  render() {
    let image = null;

    const align = this.props.align ? this.props.align.toLowerCase() : 'top left';
    const padding = this.props.padding;
    const imageUrl = this.props.src;

    let paddedH = this.props.h;
    let paddedW = this.props.w;
    let offsetX = 0;
    let offsetY = 0;

    if (this.state.imageLoaded) {
      if (padding) {
        offsetX += padding;
        offsetY += padding;
        paddedW = this.props.w - padding * 2;
        paddedH = this.props.h - padding * 2;
      }

      let scaleWidth = this.state.imageSize.width;
      let scaleHeight = this.state.imageSize.height;
      const widthRatio = paddedW / scaleWidth;
      let heightRatio = paddedH / scaleHeight;

      if (scaleWidth > paddedW || (this.props.shouldUpscale && widthRatio < heightRatio)) {
        scaleHeight *= widthRatio;
        scaleWidth = paddedW;

        //update height ratio because height changed
        heightRatio = paddedH / scaleHeight;
      }

      if (scaleHeight > paddedH || (this.props.shouldUpscale && widthRatio >= heightRatio)) {
        scaleWidth *= heightRatio;
        scaleHeight = paddedH;
      }

      if (align === 'center') {
        offsetX = this.props.w / 2 - scaleWidth / 2;
        offsetY = this.props.h / 2 - scaleHeight / 2;
      }
      //final rendered image with adjustments applied
      image = (
        <svg x={offsetX} y={offsetY}>
          <image xlinkHref={imageUrl} width={scaleWidth} height={scaleHeight} />
        </svg>
      );
    } else {
      const imageInfo = ImageProxy.getImageObject();
      imageInfo.onload = this.setImageLoaded;
      imageInfo.src = imageUrl;
    }

    return image;
  }
}
